function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 3.2A3.2 3.2 0 0 1 10.2 0H13c23.196 0 42 18.804 42 42v2.8a3.2 3.2 0 0 1-3.2 3.2H34.2a3.2 3.2 0 0 1-3.2-3.2V42c0-9.941-8.059-18-18-18h-2.8A3.2 3.2 0 0 1 7 20.8V3.2z"
});

var SvgSpectrum = function SvgSpectrum(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 62 62"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjIgNjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTcsMy4yIEM3LDEuNDMzIDguNDMzLDAgMTAuMiwwIEwxMywwIEMzNi4xOTYsMCA1NSwxOC44MDQgNTUsNDIgTDU1LDQ0LjggQzU1LDQ2LjU2OCA1My41NjcsNDggNTEuOCw0OCBMMzQuMiw0OCBDMzIuNDMzLDQ4IDMxLDQ2LjU2OCAzMSw0NC44IEwzMSw0MiBDMzEsMzIuMDU5IDIyLjk0MSwyNCAxMywyNCBMMTAuMiwyNCBDOC40MzMsMjQgNywyMi41NjggNywyMC44IEw3LDMuMiBaIj48L3BhdGg+Cjwvc3ZnPg==";
export { SvgSpectrum as ReactComponent };